exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js??ref--4-1!../../../../node_modules/postcss-loader/index.js??postcss!../auth-form.css"), "");

// module
exports.push([module.id, "\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/auth/signin/signin.component.css
// module id = ../../../../../src/app/auth/signin/signin.component.css
// module chunks = main